window.ProductQuickAdd = (function () {

  async function addToCartAndUpdateDrawer(variantId, button) {
    const wrapper = button.closest('.product-card__variants--size');

    try {
      if (wrapper) wrapper.classList.add('loading');

      wrapper?.querySelectorAll('.variant-size').forEach(btn => {
        btn.setAttribute('aria-disabled', 'true');
      });

      wrapper?.querySelectorAll('.variant-size').forEach(btn => {
        btn.classList.remove('active');
      });
      button.classList.add('active');

      const cart = document.querySelector('cart-drawer');
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);

      if (cart) {
        formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(button);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      const addRes = await fetch(`${routes.cart_add_url}`, config);
      const responseText = await addRes.text();
      let addData = {};

      if (responseText) {
        try {
          addData = JSON.parse(responseText);
        } catch (parseErr) {
          console.error('Add to cart error: invalid response', addRes.status, responseText.slice(0, 200));
          return;
        }
      }

      if (!addRes.ok || addData.status) {
        console.error('Add to cart error:', addData.status ? addData : addRes.status);
        return;
      }

      if (cart) {
        cart.renderContents(addData);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      } else {
        window.location = routes.cart_url;
      }

    } catch (err) {
      console.error('Cart error:', err);
    } finally {
      if (wrapper) wrapper.classList.remove('loading');

      wrapper.closest('.product-card__quick-add')?.classList.remove('is-active');

      wrapper?.querySelectorAll('.variant-size').forEach(btn => {
        btn.removeAttribute('aria-disabled');
      });
    }
  }

  function handleClick(e) {
    const trigger = e.target.closest('.quick-add__trigger');
    if (trigger) {
      const card = trigger.closest('.product-card');
      if (!card) return;

      const quickAddWrapper = card.querySelector('.product-card__quick-add');
      if (!quickAddWrapper) return;

      quickAddWrapper.classList.add('is-active');
      return;
    }

    const button = e.target.closest('.variant-size[data-value]');
    if (button) {
      e.preventDefault();

      if (button.classList.contains('soldout')) return;

      const variantId = button.dataset.value;
      if (!variantId) return;

      addToCartAndUpdateDrawer(variantId, button);
    }
  }

  let initialized = false;

  function init() {
    if (initialized) return;
    initialized = true;
    document.addEventListener('click', handleClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return { init };

})();
